import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { VisitReservation } from './visitor-upfront-registration-list.model';

@Injectable({
  providedIn: 'root'
})
export class VisitorUpfrontRegistrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getAllVisitReservations(): Observable<VisitReservation[]> {
    const url = `/client/visitreservation/reservations`;
    return this.appServerAPI.execute<VisitReservation[]>(url, {});
  }

}
